module.exports = __webpack_public_path__ + "img/atenciones.657cb084.png";